module.exports = window["core-js/modules/es.string.replace.js"];